<script setup lang="ts">
import { ref, watch, onMounted } from 'vue';

import { BorrowingTransactionDetail } from '@/types/borrowing.type';

const props = defineProps<{
  data: BorrowingTransactionDetail;
}>();

const getLocalTime = (date: Date): Date => {
  const timeZoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
  return new Date(date.getTime() + timeZoneOffset);
};

const hour = ref<number>(0);
const minutes = ref<number>(0);
const seconds = ref<number>(0);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const counterInterval = ref<any>();

watch(props, () => props.data.confirmationEmailExpiredAt && setRemainingTime());
onMounted(() => props.data.confirmationEmailExpiredAt && setRemainingTime());

const hasTimedOut = ref<boolean>(false);

const setRemainingTime = (): void => {
  clearInterval(counterInterval.value);
  const expiredAt = new Date(props.data.confirmationEmailExpiredAt).getTime();
  const currentTime = new Date().getTime();
  const remainingTime = getLocalTime(new Date(expiredAt - currentTime));
  if (expiredAt < currentTime) {
    hasTimedOut.value = true;
  } else {
    hour.value = remainingTime.getHours();
    minutes.value = remainingTime.getMinutes();
    seconds.value = remainingTime.getSeconds();
    counterInterval.value = setInterval(countDown, 1000);
    setTimeout(() => {
      clearInterval(counterInterval.value);
      hasTimedOut.value = true;
    }, Math.abs(remainingTime.getTime()));
  }
};

const countDown = (): void => {
  if (seconds.value > 0) {
    seconds.value--;
  } else if (minutes.value > 0) {
    minutes.value--;
    seconds.value = 59;
  } else if (hour.value > 0) {
    hour.value--;
    minutes.value = 59;
    seconds.value = 59;
  } else {
    hour.value = 0;
    minutes.value = 0;
    seconds.value = 0;
  }
};
</script>
<template>
  <template v-if="data.confirmationEmailSentAt">
    <span v-if="data.confirmationEmailConfirmed">-</span>
    <span v-else-if="!data.confirmationEmailConfirmed && hasTimedOut">
      Confirmation timed out
    </span>
    <span v-else> Remaining {{ hour }} hour(s), {{ minutes }} minute(s)</span>
  </template>
  <template v-else>
    <span>-</span>
  </template>
</template>
